module.exports = __webpack_public_path__ + "img/logo-small.f3e02ea9.svg";